import { getUser } from '@/services/user-service/user.service';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';

/** `refetchInterval` polls for the one observer that asks; the others keep the stale time. */
export const useUser = ({ refetchInterval }: { refetchInterval?: number | false } = {}) => {
  const {
    data: userData,
    error,
    isFetched,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ReactQueryKeys.USER(),
    queryFn: () => getUser(),
    staleTime: 5 * 60 * 1000,
    refetchInterval,
  });

  return { userData, error, isFetched, isLoading, refetch };
};
